
import s0 from '~/.nuxt/gb-cms/sections/AccommodationForm'
import s1 from '~/.nuxt/gb-cms/sections/ContactForm'
import s2 from '~/.nuxt/gb-cms/sections/ContactSection'
import s3 from '~/.nuxt/gb-cms/sections/AboutUs'
import s4 from '~/.nuxt/gb-cms/sections/AccommodationFeatures'
import s5 from '~/.nuxt/gb-cms/sections/BlogList'
import s6 from '~/.nuxt/gb-cms/sections/HeroSlider'
import s7 from '~/.nuxt/gb-cms/sections/NewsletterForm'
import s8 from '~/.nuxt/gb-cms/sections/NumberList'
import s9 from '~/.nuxt/gb-cms/sections/OurOfferSlider'
import s10 from '~/.nuxt/gb-cms/sections/ReviewSlider'
import s11 from '~/.nuxt/gb-cms/sections/WhyUs'
import s12 from '~/.nuxt/gb-cms/sections/PrivacyPolicy'
import s13 from '~/.nuxt/gb-cms/sections/SingleProduct'

const sectionMapper = {
	'accommodation-form': s0,
	'contact-form': s1,
	'contact-section': s2,
	'about-us': s3,
	'accommodation-features': s4,
	'blog-list': s5,
	'hero-slider': s6,
	'newsletter-form': s7,
	'number-list': s8,
	'our-offer-slider': s9,
	'review-slider': s10,
	'why-us': s11,
	'privacy-policy': s12,
	'single-product': s13
}

export default sectionMapper
